<template>
  <div class="text-xs-center">
    <v-dialog v-model="dialog" class="popupprop" width="80%">
      <!-- button to change the photo / open the popUp -->
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          color="grey lighten-2"
          @click="analyticAddOtherSpecialty"
          style="font-size: 10px; outline:none;"
          class="mb-1"
          small
          rounded
          elevation="0"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </template>

      <v-card>
        <v-card-actions class="pt-0 pb-0">
          <v-spacer></v-spacer>

          <!-- button to cancel the upload / close pop-up -->
          <v-btn
            color="purple darken-4"
            text
            style="outline:none;"
            @click="dialog=false"
          >{{ $t('LoggedArea.Settings.SpecialtyPopUp.btnCancel') }}</v-btn>
        </v-card-actions>

        <v-divider style="margin: 0px; height:0.1px;" />
        <v-text-field
          class="px-2"
          widht="100%"
          v-model="search"
          append-icon="mdi-magnify"
          :label="$t('LoggedArea.Settings.SpecialtyPopUp.searchSpecialty')"
          single-line
        />

        <Specialty
          class="px-0 py-2 mx-0"
          @changespecialty="specialty=$event"
          :specialties="specialties"
        />

      <a style="color: #4A148C;text-decoration-color: #4A148C;" href="https://forms.gle/H2evP47wX5JdieD28" target="_blank"><div class="body-2 ml-2">{{ $t('LoggedArea.Settings.Specialty.requesttag') }}</div></a>


        <v-divider style="margin-top:30px; margin-bottom: 0px;" />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { analytics } from "@/config/firebaseConfig";
import Specialty from "./Specialty";
export default {
  props: ["lastSpecialty", "changespecialty"],
  components: {
    Specialty,
  },
  mounted() {
    this.specialties = this.initialSpecialties;
  },
  data() {
    return {
      dialog: false,
      specialty: "",
      specialties: "",
      search: "",
    };
  },
  computed: {
    initialSpecialties() {
      return this.$t("LoggedArea.Settings.SpecialtyPopUp.listSpecialtiesPopUp");
    },
    searching() {
      if (!this.search) return this.specialties;

      const search = this.search.toLowerCase();

      return this.initialSpecialties.filter((specialty) => {
        const text = specialty.toLowerCase();
        return text.indexOf(search) > -1;
      });
    },
  },
  watch: {
    search(newSearch) {
      if (newSearch == "") {
        this.specialties = this.initialSpecialties;
        return this.specialties;
      }
      this.specialties = this.searching;
    },
    specialty() {
      // this.$emit('changeSpecialty', this.specialty)
      this.$emit("addSpecialty", this.specialty);
      this.dialog = false;
    },
    lastSpecialty(newSpecialty) {
      this.initialSpecialties.push(newSpecialty);
    },
    changeSpecialty(newSpecialty) {
      const contains = this.initialSpecialties.indexOf(newSpecialty);
      if (contains <= -1) this.initialSpecialties.push(newSpecialty);
    },
  },
  methods: {
    analyticAddOtherSpecialty() {
      analytics.logEvent("Btn_OtherSpec");
    },
  },
};
</script>

<style>
</style>